import { useNavigate } from "react-router-dom";
import { useCallback } from "react";

export function useAuthCheck() {
    const navigate = useNavigate();

    // Vérifie si localStorage est accessible (Firefox bloque parfois)
    const isStorageAccessible = () => {
        try {
            const testKey = "__test__";
            localStorage.setItem(testKey, "1");
            localStorage.removeItem(testKey);
            return true;
        } catch (e) {
            console.warn("⚠️ localStorage inaccessible :", e);
            return false;
        }
    };

    // Fonction utilitaire pour décoder le JWT
    const parseJwt = (token) => {
        try {
            const base64Payload = token.split(".")[1];
            return JSON.parse(atob(base64Payload));
        } catch (e) {
            console.warn("Token invalide :", e);
            return null;
        }
    };

    const checkToken = useCallback(() => {
        if (!isStorageAccessible()) {
            // Firefox bloque souvent l'accès au stockage local si origine incohérente
            console.warn("Stockage non accessible, redirection sécurisée");
            setTimeout(() => navigate("/"), 0);
            return false;
        }

        const token = localStorage.getItem("token");

        if (!token) {
            localStorage.removeItem("token");
            localStorage.removeItem("role");
            setTimeout(() => navigate("/"), 0);
            return false;
        }

        const payload = parseJwt(token);

        if (!payload) {
            localStorage.removeItem("token");
            localStorage.removeItem("role");
            setTimeout(() => navigate("/"), 0);
            return false;
        }

        // Stocke le rôle / ID utilisateur si présent
        if (payload.sub) {
            try {
                localStorage.setItem("role", payload.sub);
            } catch (e) {
                console.warn("Impossible d'écrire dans localStorage :", e);
            }
        }

        // Vérifie l'expiration du token
        const now = Math.floor(Date.now() / 1000);
        if (payload.exp && payload.exp < now) {
            console.log("Token expiré, redirection...");
            localStorage.removeItem("token");
            localStorage.removeItem("role");
            setTimeout(() => navigate("/"), 0);
            return false;
        }

        return true;
    }, [navigate]);

    return { checkToken };
}
